<template>
  <v-tour name="myTour" :steps="steps" :options="tourOptions" :callbacks="myCallbacks">
    <template slot-scope="tour">
    <transition name="fade">
      <v-step
        :step="tour.steps[tour.currentStep]"
        v-if="tour.steps[tour.currentStep]"
        :key="tour.currentStep"
        :previous-step="tour.previousStep"
        :next-step="tour.nextStep"
        :stop="tour.stop"
        :skip="tour.skip"
        :is-first="tour.isFirst"
        :is-last="tour.isLast"
        :labels="tour.labels"
        style="background: #fff; box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1); filter:none; border-radius:7px; text-align:left;"
        class="pa-4"
      >
        <template v-if="tour.currentStep === 0">
          <div slot="content" class="relative">
            <span class="steps-count">{{tour.currentStep +  1}}/{{tour.steps.length}}</span>
            <div v-html="tour.steps[tour.currentStep].content"></div>
          </div>
          <div slot="actions">
            <v-layout>
              <v-flex>
                <v-btn color="error" class="mr-1 tinybut white--text text-none" depressed small @click="stopTour">
                  skip
                </v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" class="tinybut white--text text-none" depressed small @click="tour.nextStep">
                  next
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <template v-else-if="tour.currentStep === 5">
          <div slot="content" class="relative">
            <span class="steps-count">{{tour.currentStep +  1}}/{{tour.steps.length}}</span>
            <div v-html="tour.steps[tour.currentStep].content"></div>
          </div>
          <div slot="actions">
            <v-layout>
              <v-flex>
                <v-btn color="primary" class="mr-1 tinybut white--text text-none" depressed small @click="tour.previousStep">
                  prev
                </v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn color="error" class="mr-1 tinybut white--text text-none" depressed small @click="stopTour">
                  finish
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <template v-else>
          <div slot="content" class="relative">
            <span class="steps-count">{{tour.currentStep +  1}}/{{tour.steps.length}}</span>
            <div v-html="tour.steps[tour.currentStep].content"></div>
          </div>
          <div slot="actions">
            <v-layout>
              <v-flex>
                <v-btn color="error" class="mr-1 tinybut white--text text-none" depressed small @click="stopTour">
                  skip
                </v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" class="mr-1 tinybut white--text text-none" depressed small @click="tour.previousStep">
                  prev
                </v-btn>
                <v-btn color="primary" class="tinybut white--text text-none" depressed small @click="tour.nextStep">
                  next
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>
      </v-step>
    </transition>
  </template>
  </v-tour>
</template>

<script>
export default {
  name: 'DashTour',
  data () {
    return {
      tourOptions: {
        labels: {
          buttonSkip: 'Skip',
          buttonPrevious: 'Back',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      steps: [
        {
          target: false,
          content: '<h2 class="pb-2 fadegrey--text">Welcome to Worktabs</h2><p>Worktabs is super simple to use but here’s a few quick tips to get you started…</p>'
        },
        {
          target: false,
          content: '<h2 class="pb-2 fadegrey--text">5 Columns</h2><p>Worktabs is comprised of 5 columns. These are used to organise your work depending on the state of each job’s progress.</p>'
        },
        {
          target: '[data-v-step="3"]',
          content: '<h2 class="pb-2 fadegrey--text">Add a job</h2><p>Click the \'+\' button at the top of a column to add a new job. Move the job cards between columns depending on their state. Click on a job to edit it’s details or invoice it.</p>'
        },
        {
          target: '[data-v-step="totalsbut"]',
          content: '<h2 class="pb-2 fadegrey--text">Totals</h2><p>Quickly view your income totals using the handy ‘totals’ button.</p>'
        },
        {
          target: false,
          content: '<h2 class="pb-2 fadegrey--text">Menu</h2><p>In here you can view your invoices, quotes, client details and repeat jobs as well as manage your account settings, payment settings and business details.</p>'
        },
        {
          target: '[data-v-step="logo"]',
          content: '<h2 class="pb-2 fadegrey--text">Work organiser page</h2><p>Wherever you are in the app, click here to return to the work organiser page.</p>'
        }
      ],
      myCallbacks: {
        onNextStep: this.nextStepCallback,
        onPreviousStep: this.previousStepCallback
      }
    }
  },
  computed: {
    tourSteps () {
      return this.tour.steps
    }
  },
  methods: {
    nextStepCallback (currentStep) {
      const thisStep = currentStep + 1
      if (thisStep === 4) {
        this.$emit('toggleDrawer', true)
      }
      if (thisStep !== 4) {
        this.$emit('toggleDrawer', false)
      }
    },
    previousStepCallback (currentStep) {
      const thisStep = currentStep - 1
      if (thisStep === 4) {
        this.$emit('toggleDrawer', true)
      }
      if (thisStep !== 4) {
        this.$emit('toggleDrawer', false)
      }
    },
    startTour () {
      this.$tours['myTour'].start()
    },
    stopTour () {
      this.$tours['myTour'].stop()
    }
  }
}
</script>

<style lang="scss" >
.v-step{
  z-index:9999;
}
.v-step{
  min-width:280px;
  h2{
    color:var(--dark-text);
    font-size:1.4rem;
  }
  p{
    font-size:.9rem;
    font-weight:500;
    color:var(--dark-text);
  }
  span {
    color:var(--light-text);

  }
}
.xsOnly .v-step h2{
  font-size:1.2rem;
}

.steps-count{
  position:absolute;
  top:29px;
  right:25px;
}
.v-step{
  button{
    font-size: 13px;
  }
}
.v-step__arrow{
  border-color:#fff !important;
}
.v-step[x-placement^=bottom] .v-step__arrow{
  border-left-color:transparent !important;
  border-right-color:transparent !important;
  border-top-color:transparent !important;
  border-bottom-color:#fff !important;
}
.v-step[x-placement^=top] .v-step__arrow{
  border-left-color:transparent !important;
  border-right-color:transparent !important;
  border-bottom-color:transparent !important;
  border-top-color:#fff !important;
}

span.forMobile{

  .smAndUp &{
    display:none;
  }
}
span.forDesktop{

  .xsOnly &{
    display:none;
  }
}
</style>
